
import { AuthCheck } from "@/components/auth/AuthCheck";
import { Dialog } from "@/components/ui/dialog";
import { ProgramDetailWrapper } from "@/components/programs/detail/ProgramDetailWrapper";
import { ProgramDetailLoading } from "@/components/programs/detail/ProgramDetailLoading";
import { ProgramDetailNotFound } from "@/components/programs/detail/ProgramDetailNotFound";
import { ProgramHeader } from "@/components/programs/detail/ProgramHeader";
import { ConfirmDeleteDialog } from "@/components/programs/detail/ConfirmDeleteDialog";
import { ProgramDetailContent } from "@/components/programs/detail/ProgramDetailContent";
import { useProgramDetail } from "@/components/programs/detail/useProgramDetail";
import { useUserProfile } from "@/hooks/useUserProfile";
import { ProgramActions } from "@/components/programs/detail/ProgramActions";
import { useNavigate } from "react-router-dom";

export default function ProgramDetail() {
  const {
    program,
    programData,
    loading,
    deleteDialogOpen,
    setDeleteDialogOpen,
    isDeleting,
    isDuplicating,
    handleDeleteProgram,
    handleDuplicateProgram
  } = useProgramDetail();
  
  const { avatarUrl, name } = useUserProfile();
  const navigate = useNavigate();

  if (loading) {
    return <ProgramDetailLoading avatarUrl={avatarUrl} name={name} />;
  }

  if (!program) {
    return <ProgramDetailNotFound avatarUrl={avatarUrl} name={name} />;
  }

  const mergedData = {
    ...program.program_data || {},
    ...programData || {}
  };
  
  const tier = mergedData.tier || program.tier || 'Beginner';
  const clientCount = (mergedData.assigned_clients?.length || 0);
  
  return (
    <AuthCheck>
      <ProgramDetailWrapper avatarUrl={avatarUrl} name={name}>
        <main className="p-6 relative">
          <ProgramHeader 
            programName={mergedData.name || program.name || 'Unnamed Program'}
            startDate={mergedData.startDate || program.start_date}
            tier={tier}
            clientCount={clientCount}
          />

          <ProgramActions 
            onDeleteClick={() => setDeleteDialogOpen(true)}
            onDuplicateClick={handleDuplicateProgram}
            isDuplicating={isDuplicating}
          />
          
          <ProgramDetailContent 
            program={program} 
            programData={programData} 
          />
        </main>
      </ProgramDetailWrapper>

      <ConfirmDeleteDialog 
        isOpen={deleteDialogOpen}
        isDeleting={isDeleting}
        onClose={() => setDeleteDialogOpen(false)}
        onDelete={handleDeleteProgram}
      />
    </AuthCheck>
  );
}

